// InvoicePreviewModal.js
import React, { useState } from "react";
import { FaTimes, FaWhatsapp, FaSave, FaSpinner } from "react-icons/fa";
import { motion } from "framer-motion";
import { IoCloseOutline } from "react-icons/io5";

const InvoicePreviewModal = ({ onClose, onSave, onSendWhatsApp, pdfBlob }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSave = async (sendWhatsApp) => {
    setIsSubmitting(true);
    await onSave(sendWhatsApp);
    setIsSubmitting(false);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed inset-0 z-50 overflow-y-auto"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="min-h-screen px-4 text-center">
        <span className="inline-block h-screen align-middle" aria-hidden="true">
          &#8203;
        </span>
        <motion.div
          initial={{ scale: 0.9 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="inline-block w-full max-w-6xl my-8 overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl"
        >
          <div className="bg-gradient-to-r from-blue-400 to-purple-400 text-white px-8 py-6 relative">
            <h2 className="text-3xl font-bold mb-2">Invoice Preview</h2>
            <button
              onClick={onClose}
              className="absolute  top-1/2 right-10 -translate-y-1/2 border-transparent text-white  hover:text-gray-700 bg-transparent  hover:bg-white focus:ring-4 focus:outline-none focus:ring-gray-200  px-0 w-10 h-10 inline-flex justify-center items-center rounded-full
              text-5xl  transition ease-in-out duration-300 "
            >
              <IoCloseOutline />
              <span className="sr-only">Close</span>
            </button>
          </div>
          <div className="px-8 py-6">
            {/* Render the invoice PDF preview */}
            <iframe
              src={URL.createObjectURL(pdfBlob)}
              width="100%"
              height="600px"
              title="Invoice Preview"
            ></iframe>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => handleSave(false)}
              id={"invoiceSaveBtnAtm"}
              disabled={isSubmitting}
              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 mr-2"
            >
              {isSubmitting ? (
                <FaSpinner
                  className="h-4 w-4 mr-2 animate-spin"
                  aria-hidden="true"
                />
              ) : (
                <>
                  <FaSave className="h-4 w-4 mr-2" aria-hidden="true" />
                  Save
                </>
              )}
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => handleSave(true)}
              id={"invoiceSendWhatsAppAtm"}
              disabled={isSubmitting}
              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mr-2"
            >
              {isSubmitting ? (
                <FaSpinner
                  className="h-4 w-4 mr-2 animate-spin"
                  aria-hidden="true"
                />
              ) : (
                <>
                  <FaWhatsapp className="h-4 w-4 mr-2" aria-hidden="true" />
                  Whatsapp & Save
                </>
              )}
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={onClose}
              id={"invoiceKeepEditingAtm"}
              className="inline-flex justify-center py-2 px-4 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mr-2"
            >
              Keep Editing
            </motion.button>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default InvoicePreviewModal;
